export default __webpack_public_path__ + "static/media/logobap.ffd1411e.png";